// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/SideMenuHeader.scss
// module id = ./src/styles/SideMenuHeader.scss
// module chunks = 0